import clientLogo from "../../images/clients/Colored/Hush_Puppies.png"

const hushPuppiesPakistan = {
  pageTitle: "Visiomate - Hush Puppies Pakistan Case Study",
  metaDescription:
    "Dynamics 365 support, an Xstak integration, a bulk distribution tool and retail changes for Firhaj Footwear, the licensee of Hush Puppies in Pakistan.",
  clientName: "Hush Puppies Pakistan",
  bannerSummary: "Dynamics 365 support, integrations and retail changes for Firhaj Footwear",
  introHeading: "Dynamics 365 Support and Integrations for Hush Puppies Pakistan",
  heroImageAlt: "Warehouse of boxed stock",
  clientLogoSrc: clientLogo,
  about:
    "Firhaj Footwear (Pvt) Ltd is the official licensee of Hush Puppies in Pakistan, where the brand has been selling since 1992. Firhaj also holds the CAT licence. The business runs its stores and supply chain on Dynamics 365 and needed a partner to extend it, connect it to its online channels and keep it running.",

  challengesIntro: "Dynamics 365 ran the business, but it needed to do more than its standard setup allowed.",
  challenges: [
    {
      title: "Channels Out of Sync",
      desc: "Orders, stock and prices had to match between Dynamics 365 and the Xstak online store.",
    },
    {
      title: "Slow Bulk Stock Transfers",
      desc: "Sending stock to many stores meant creating transfer orders one by one, each user needing a licence.",
    },
    {
      title: "Purchasing and Barcodes That Didn't Fit",
      desc: "The standard purchase process and barcode layouts didn't match how Firhaj works.",
    },
    {
      title: "A Point of Sale That Needed Changes",
      desc: "The Dynamics 365 retail point of sale needed adjusting for their stores.",
    },
  ],

  solutionsIntro: "We extended, connected and supported their Dynamics 365.",
  solutions: [
    {
      num: "01",
      text: "Xstak Integration",
      desc: "Orders, stock and prices synced with the Xstak online store, on separate schedules for sales and stock.",
    },
    {
      num: "02",
      text: "Distribution Utility",
      desc: "Bulk transfer orders to many stores at once, filtered by category, hierarchy and size, from outside Dynamics 365.",
    },
    {
      num: "03",
      text: "Barcode Designs",
      desc: "Barcode labels designed for Firhaj's products.",
    },
    {
      num: "04",
      text: "Purchase Process Changes",
      desc: "The purchase flow modified to match how Firhaj buys.",
    },
    {
      num: "05",
      text: "Point of Sale Changes",
      desc: "The Dynamics 365 retail point of sale adjusted for their stores.",
    },
    {
      num: "06",
      text: "Reports and Ongoing Support",
      desc: "New reports, new features and day-to-day Dynamics 365 support.",
    },
  ],

  resultsIntro: "Firhaj's Dynamics 365 now connects its stores, warehouse and online channel.",
  metrics: [
    { metric: "In sync", label: "Orders, stock and prices between Dynamics 365 and Xstak" },
    { metric: "Bulk", label: "Transfer orders to many stores in one go, instead of one by one" },
    { metric: "No licence", label: "Needed for warehouse staff to create bulk transfers" },
  ],
  outcomes: [
    "Online and store channels work from the same stock and prices",
    "Distributing new stock across stores takes far less time",
    "Purchasing, barcodes and the point of sale fit the way the business works",
  ],

  relatedLinks: [
    {
      to: "/caseStudies/projects/borjan",
      label: "See Borjan's reporting story",
      note: "25+ supply chain and finance reports built on Dynamics 365.",
    },
    {
      to: "/caseStudies/projects/cakesAndBakes",
      label: "Read how Cakes & Bakes modernised its Dynamics 365",
      note: "Manufacturing, inventory and dispatch moved off registers and spreadsheets.",
    },
  ],
}

export default hushPuppiesPakistan
